// @flow
import DeviceDesktop from '@react/react-spectrum/Icon/DeviceDesktop';
import DevicePhone from '@react/react-spectrum/Icon/DevicePhone';
import DeviceTablet from '@react/react-spectrum/Icon/DeviceTablet';

export const iconMapping = {
	desktop: DeviceDesktop,
	mobile: DevicePhone,
	tablet: DeviceTablet
};

export const categoryMap = {
	'combine-images': { // Combine photos
		id: 'combine-images',
		products: ['PHSP'],
		name: 'apps.appPickerPhotoPlan.categoryHeading.combine-images',
		imgSrc: '/assets/apps/appPickerPhotoPlan/combine-images.png'
	},
	'organize-photos': { // Organize photos
		id: 'organize-photos',
		products: ['LRCC', 'LTRM'],
		name: 'apps.appPickerPhotoPlan.categoryHeading.organize-photos',
		imgSrc: '/assets/apps/appPickerPhotoPlan/organize-photos.png'
	},
	'edit-photos': { // Edit multiple photos
		id: 'edit-photos',
		products: ['LRCC', 'PHSP', 'LTRM'],
		name: 'apps.appPickerPhotoPlan.categoryHeading.edit-photos',
		imgSrc: '/assets/apps/appPickerPhotoPlan/edit-photos.png'
	},
	'remove-objects': { // Remove objects
		id: 'remove-objects',
		products: ['PHSP'],
		name: 'apps.appPickerPhotoPlan.categoryHeading.remove-objects',
		imgSrc: '/assets/apps/appPickerPhotoPlan/remove-objects.png'
	}
};

export const productCardDetails = {
	LRCC: {
		backgroundImageSrc: '/assets/apps/appPickerPhotoPlan/LightroomimgNewAppPicker.png',
		desc: 'apps.appPickerPhotoPlan.productCard.desc.LRCC',
		platforms: ['desktop', 'mobile', 'tablet']
	},
	PHSP: {
		backgroundImageSrc: '/assets/apps/appPickerPhotoPlan/PhotoshopimgNewAppPicker.png',
		desc: 'apps.appPickerPhotoPlan.productCard.desc.PHSP',
		platforms: ['desktop', 'tablet']
	},
	LTRM: {
		backgroundImageSrc: '/assets/apps/appPickerPhotoPlan/LightroomClassicimgNewAppPicker.png',
		desc: 'apps.appPickerPhotoPlan.productCard.desc.LTRM',
		platforms: ['desktop']
	}
};

export const productDescCardDetails = {
	PHSP: {
		cardImageSrc: '/assets/apps/appPickerPhotoPlan/Photoshopimg.png',
		desc: {
			'combine-images': 'apps.appPickerPhotoPlan.productDescCard.desc.PHSP.combine-images',
			'edit-photos': 'apps.appPickerPhotoPlan.productDescCard.desc.PHSP.edit-photos',
			'remove-objects': 'apps.appPickerPhotoPlan.productDescCard.desc.PHSP.remove-objects'
		},
		tagLine: {
			'combine-images': 'apps.appPickerPhotoPlan.productDescCard.tagLine.PHSP.combine-images',
			'edit-photos': 'apps.appPickerPhotoPlan.productDescCard.tagLine.PHSP.edit-photos',
			'remove-objects': 'apps.appPickerPhotoPlan.productDescCard.tagLine.PHSP.remove-objects'
		}
	},
	LTRM: {
		cardImageSrc: '/assets/apps/appPickerPhotoPlan/LightroomClassicimg.png',
		desc: {
			'organize-photos': 'apps.appPickerPhotoPlan.productDescCard.desc.LTRM.organize-photos',
			'edit-photos': 'apps.appPickerPhotoPlan.productDescCard.desc.LTRM.edit-photos'
		},
		tagLine: {
			'organize-photos': 'apps.appPickerPhotoPlan.productDescCard.tagLine.LTRM.organize-photos',
			'edit-photos': 'apps.appPickerPhotoPlan.productDescCard.tagLine.LTRM.edit-photos'
		}
	},
	LRCC: {
		cardImageSrc: '/assets/apps/appPickerPhotoPlan/Lightroomimg.png',
		desc: {
			'organize-photos': 'apps.appPickerPhotoPlan.productDescCard.desc.LRCC.organize-photos',
			'edit-photos': 'apps.appPickerPhotoPlan.productDescCard.desc.LRCC.edit-photos'
		},
		tagLine: {
			'organize-photos': 'apps.appPickerPhotoPlan.productDescCard.tagLine.LRCC.organize-photos',
			'edit-photos': 'apps.appPickerPhotoPlan.productDescCard.tagLine.LRCC.edit-photos'
		}
	}
};